// extracted by mini-css-extract-plugin
export default {"tdText_cursive":"CursiveSpan_tdText_cursive__s1Yw7"};